var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 385 385",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1027_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1029_",
    style: {
      fill: "#FF9811"
    },
    points: "77.326,355 83.327,385 233.318,355 157.5,355  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1030_",
    style: {
      fill: "#FF9811"
    },
    points: "307.5,340.163 377.5,326.162 318.663,31.988 203.612,55 307.5,55  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1031_",
    style: {
      fill: "#FFE98F"
    },
    d: "M157.5,150c-24.813,0-45-20.186-45-45V85h30v20c0,8.271,6.729,15,15,15V55h-15h-30 H7.5v300h69.826H157.5V150z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1032_",
    style: {
      fill: "#FFDA44"
    },
    d: "M307.5,340.163V55H203.612H202.5v50c0,24.814-20.187,45-45,45v205h75.818H307.5 V340.163z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1033_",
    style: {
      fill: "#FFDA44"
    },
    d: "M172.5,105V55h-15v65C165.771,120,172.5,113.271,172.5,105z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1034_",
    style: {
      fill: "#565659"
    },
    d: "M142.5,45c0-8.271,6.729-15,15-15s15,6.729,15,15v10v50c0,8.271-6.729,15-15,15 s-15-6.729-15-15V85h-30v20c0,24.814,20.187,45,45,45s45-20.186,45-45V55V45c0-24.813-20.187-45-45-45s-45,20.187-45,45v10h30V45z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ad9510934791ecfd3935ed7e1802df12.svg";
export { ForwardRef as ReactComponent };